import { Node_Type } from "./../../../../../ricos-schema/legacy/wix/rich_content/v1";
import { fromExternalNode } from "./fromExternalNode";
const getPluginRenderers = (context, typeMappers, nodeViewRenderers, SpoilerViewerWrapper) => {
  const convertedTypeMappers = Object.entries(typeMappers).reduce(
    (renderers, [type, pluginComponent]) => {
      if (type === Node_Type.EXTERNAL) {
        return {
          ...renderers,
          ...fromExternalNode({ pluginComponent, type, context, SpoilerViewerWrapper })
        };
      }
      return { ...renderers };
    },
    {}
  );
  return { ...convertedTypeMappers, ...nodeViewRenderers };
};
export {
  getPluginRenderers
};
//# sourceMappingURL=getPluginRenderers.js.map
